"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body className="bg-background text-fg antialiased">
        <main className="flex min-h-screen items-center justify-center p-8">
          <div className="text-center max-w-sm animate-fade-in">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-red/10">
              <AlertTriangle className="h-6 w-6 text-accent-red" />
            </div>
            <h1 className="mt-6 font-heading text-9 font-semibold tracking-tight text-fg">Something went wrong</h1>
            <p className="mt-2 text-3 text-fg-secondary leading-relaxed">
              A critical error occurred. Please try refreshing.
            </p>
            <div className="mt-8 flex items-center justify-center gap-3">
              <Button onClick={reset} size="sm">
                <RefreshCw className="mr-1.5 h-3.5 w-3.5" /> Try Again
              </Button>
              <Button variant="outline" size="sm" onClick={() => window.location.href = "/"}>
                <Home className="mr-1.5 h-3.5 w-3.5" /> Home
              </Button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
